export default __webpack_public_path__ + "static/media/cogeco.d26471dc.png";